import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { isLoggedIn, clearToken } from './lib/auth'
import api from './lib/api'
import Layout from './components/Layout'
import LandingPage from './pages/LandingPage'
import PlanSelectionPage from './pages/PlanSelectionPage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import DashboardPage from './pages/DashboardPage'
import AddVehiclePage from './pages/AddVehiclePage'
import VehicleDetailPage from './pages/VehicleDetailPage'
import AccountPage from './pages/AccountPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import ConfirmEmailPage from './pages/ConfirmEmailPage'
import ResendConfirmationPage from './pages/ResendConfirmationPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import SharedVehiclePage from './pages/SharedVehiclePage'

function ProtectedRoute({ children }) {
  const [status, setStatus] = useState(isLoggedIn() ? 'checking' : 'unauthenticated')

  useEffect(() => {
    if (!isLoggedIn()) return
    api.get('/dashboard')
      .then(() => setStatus('authenticated'))
      .catch(() => {
        clearToken()
        setStatus('unauthenticated')
      })
  }, [])

  if (status === 'checking') {
    return <div className="text-center text-gray-500 py-12">Loading...</div>
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/" replace />
  }
  return children
}

function GuestRoute({ children }) {
  if (isLoggedIn()) {
    return <Navigate to="/dashboard" replace />
  }
  return children
}

function HomeRoute() {
  const [status, setStatus] = useState(isLoggedIn() ? 'checking' : 'unauthenticated')

  useEffect(() => {
    if (!isLoggedIn()) return
    api.get('/dashboard')
      .then(() => setStatus('authenticated'))
      .catch(() => {
        clearToken()
        setStatus('unauthenticated')
      })
  }, [])

  if (status === 'checking') {
    return <div className="text-center text-gray-500 py-12">Loading...</div>
  }
  if (status === 'unauthenticated') {
    return <LandingPage />
  }
  return <Navigate to="/dashboard" replace />
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/get-started" element={<GuestRoute><PlanSelectionPage /></GuestRoute>} />
        <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
        <Route path="/register/:plan" element={<GuestRoute><RegisterPage /></GuestRoute>} />
        <Route path="/forgot-password" element={<GuestRoute><ForgotPasswordPage /></GuestRoute>} />
        <Route path="/reset-password" element={<GuestRoute><ResetPasswordPage /></GuestRoute>} />
        <Route path="/confirm-email" element={<ConfirmEmailPage />} />
        <Route path="/resend-confirmation" element={<GuestRoute><ResendConfirmationPage /></GuestRoute>} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/share/:token" element={<SharedVehiclePage />} />
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/vehicles/new" element={<AddVehiclePage />} />
          <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
          <Route path="/account" element={<AccountPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
